module.exports = __webpack_public_path__ + "img/info_type_modif.2afdd303.svg";